import { FC, HTMLAttributes, ReactElement } from 'react';

import Container from '../container';

import './index.scss';

export interface ITitle {
    rightSide?: ReactElement;
    title?: string | ReactElement;
}

export type TitleProps = ITitle & HTMLAttributes<HTMLHeadingElement>;

const Title: FC<TitleProps> = ({ title, rightSide, ...props }) => {
    return (
        <Container classNamesContainer={'title__container'}>
            <h1 {...props}>{title}</h1>

            {rightSide && rightSide}
        </Container>
    );
};

export default Title;
